export default "__VITE_ASSET__1d6f324a__"